import { Layout } from '../../layout'
import { LeftChart } from './leftChart'
import { RightChart } from './rightChart'

export const Chart = () => {
  return (
    <Layout>
      <LeftChart />
      <RightChart />
    </Layout>
  )
}
